import { useCallback, useEffect, useState } from 'react'

import { RowTypes } from '../table/TableRows'
import { TabPaneToolbar } from '../shared/TabPaneToolbar'
import { DocumentSearchBarOnChangeData } from '../shared/DocumentsSearchBar'
import { UserDocumentsTable } from '../table'
import { DocumentTabPane } from '.'
import { Text } from '@/ui'

export const COLUMNS = [
  {
    sortBy: 'createdAt',
    title: 'Date Uploaded',
  },
  {
    sortBy: 'fileName',
    title: 'File Name',
  },
]

export const Receipts: DocumentTabPane = ({ documents, tableOptions }) => {
  const [filteredDocuments, setFilteredDocuments] = useState(documents)

  useEffect(() => {
    setFilteredDocuments(documents)
  }, [documents])

  const onSearch = useCallback((data: DocumentSearchBarOnChangeData) => {
    setFilteredDocuments(data.filtered)
  }, [])

  return (
    <>
      <TabPaneToolbar
        documents={documents}
        onSearch={onSearch}
        rightElement={null}
      >
        <Text>
          Heard doesn&apos;t require receipts, but you may use this section for
          your own records. We recommend keeping track of any receipts over $75
          in value.
        </Text>
      </TabPaneToolbar>

      <UserDocumentsTable
        columns={COLUMNS}
        documents={filteredDocuments}
        rowType={RowTypes.RECEIPT}
        tableOptions={tableOptions}
      />
    </>
  )
}

Receipts.paneDescription =
  'This section displays your uploaded receipts. It is not required to upload receipts to Heard, but feel free to use this section to stay organized! We recommend keeping track of receipts that are more than $75 in value for your records.'
Receipts.paneTitle = 'Receipts'
